import CardInfoTooltip from './CardInfoTooltip';

export default CardInfoTooltip;

export type { CardTooltipContent, ICardInfoTooltipProps } from './CardInfoTooltip';
